export const formatTwoDigitValues = (value: Number): string => {
  if (value) {
    return value < 10 ? `0${value}` : value.toString();
  }
};
